import { useState } from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';

import { Rotator, Logo } from './Components';
import { Game, HowToPlay, Welcome, GameOver, Leaderboard } from './Screens';

const screens = {
    'welcome': Welcome,
    'how-to-play': HowToPlay,
    'game': Game,
    'game-over': GameOver,
    'leaderboard': Leaderboard,
}

const HazardPerceptionGame = () => {
    const [screen, setScreen] = useState('welcome');
    const [game, setGame] = useState('flats');
    const [score, setScore] = useState(0)

    const Component = screens[screen] ?? null;

    return (
        <Unauthenticated container={false} header={false}>
            <div className="bg-app-turquoise text-white h-screen">
                <Rotator />

                <Logo />

                {Component && (
                    <Component
                        setScreen={setScreen}
                        game={game}
                        setGame={setGame}
                        setScore={setScore}
                        score={score}
                    />
                )}
            </div>
        </Unauthenticated>
    );
};

export default HazardPerceptionGame;
